import { size } from "lodash";
import { toast } from "../../components/ui/Toast/useToast";
import { ArrowSquareOut, BookDocsOpenIcon, FileTextIcon, FolderIcon, ListCheckIcon, RoadHorizonIcon, ShieldCheckDocsIcon, ShieldCheckIcon, SignatureIcon, TagIcon } from "../../icons";

export const validateResponse = (response) => {
  if (response?.exceptions && size(response.exceptions) > 0) {
    const message = 
        response?.exceptions?.invalid?.plateno ??
        response?.exceptions?.invalid?.categoryId ??
        response?.exceptions?.[0]
    toast({
      variant: 'destructive',
      description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
    });
    return false;
  }
  return true;
};

export const documentIcon = (docName) => {
  switch (docName.trim()) {
    case "Παράρτημα - Ιδιωτικό Συμφωνητικό" :
    case "Σύμβαση" :
    case "Μεταφορά Μίσθωσης" :
    case "Credit Facility - Ιδιωτικό Συμφωνητικό" :
      return <SignatureIcon />
    case "Τροποποιήσεις Παραρτήματος" :
      return <FolderIcon />
    case "Quick Driver's Guide" :
    case "Quick Driver’s Guide" :
      return <BookDocsOpenIcon />
    case "Άδεια Κυκλοφορίας" :
      return <RoadHorizonIcon />
    case "Βεβαιώσεις Ασφάλισης" :
    case "Βεβαίωση Ασφάλισης" :
      return <ShieldCheckDocsIcon />
    case "KTEO" :
      return <ListCheckIcon />
    case "Βεβαίωση Λιανικής Τιμής Προ Φόρων" :
    case "Βεβαίωση ΛΤΠΦ" :
      return <TagIcon />
    case "Συμπληρωμένες Δηλώσεις Ατυχήματος" :
      return <FileTextIcon />
    case "Σήμα κυκλοφορίας εντός δακτυλίου" :
    case "Βεβαίωση μη οφειλής τελών κυκλοφορίας" :
    case "Σήμα δωρεάν στάθμευσης ηλεκτροκίνητου οχήματος" :
    case "Βεβαίωση Οδηγού" :
    case "Βεβαίωση Χρήσης" :
      return <ArrowSquareOut />
    default :
      return <></>
  }
}

const getCommonValueOrNull = (items, field) => {
  if (!items?.length) return null;

  const firstValue = items[0]?.[field];

  const allSame = items.every((item) => {
    const currentValue = item?.[field];

    // handle arrays/objects safely
    if (
      typeof firstValue === "object" &&
      firstValue !== null &&
      typeof currentValue === "object" &&
      currentValue !== null
    ) {
      return JSON.stringify(currentValue) === JSON.stringify(firstValue);
    }

    return currentValue === firstValue;
  });

  return allSame ? firstValue : null;
};

export const normalizeDocumentData = (docData = []) => {
    
    if (!Array.isArray(docData)) {
        return [];
    }

    const groupedByCategoryName = docData.reduce((acc, document) => {
        const key = document?.categoryName ?? "UNKNOWN_CATEGORY";

        if (!acc[key]) {
        acc[key] = [];
        }

        acc[key].push(document);
        return acc;
    }, {});

    return Object.values(groupedByCategoryName).map((group) => {
        // If only one item, keep the original flat shape
        if (group.length === 1) {
        const document = group[0];

        return {
            id: document?.uuid,
            category: document?.categoryId,
            name: document?.categoryName,
            type: document?.type ?? null,
            url: document?.url ?? null,
            metadata: document?.metadata ?? [],
            isExpandable: false,
        };
        }

        // If multiple items share the same categoryName, group them
        const first = group[0];

        return {
        // Keep common values where possible, otherwise null
        // For UI stability, we keep a synthetic id fallback if uuid differs
        id:
            getCommonValueOrNull(group, "uuid") ??
            `group-${first?.categoryId ?? "unknown"}-${first?.categoryName ?? "unknown"}`,

        category: getCommonValueOrNull(group, "categoryId"),
        name: getCommonValueOrNull(group, "categoryName"),
        link: getCommonValueOrNull(group, "url"),
        type: getCommonValueOrNull(group, "type"),
        url: getCommonValueOrNull(group, "url"),
        metadata: getCommonValueOrNull(group, "metadata"),

        isExpandable: true,

        subDocuments: group.map((document) => ({
            id: document?.uuid,
            category: document?.categoryId,
            name: document?.categoryName,
            type: document?.type ?? null,
            url: document?.url ?? null,
            metadata: document?.metadata ?? [],
            isExpandable: false,
        })),
        };
    });
};
